<template>
  <a-upload
    name="name"
    list-type="picture"
    :action="action"
    :accept="accept"
    :file-list="fileList"
    :before-upload="handleBeforeUpload"
    @change="handleChange"
  >
    <a-button :disabled="maxed">
      <a-icon type="upload"></a-icon>
      选取文件
    </a-button>
    <a-tooltip v-if="tooltip">
      <template slot="title">
        {{ tooltip }}
      </template>
      <a-icon type="question-circle" style="margin-left: 12px" />
    </a-tooltip>
  </a-upload>
</template>

<script>
export default {
  name: 'Upload',

  props: {
    action: {
      type: String,
      default: process.env.VUE_APP_API_UPLOAD_URL,
    },

    tooltip: {
      type: String,
    },

    fileList: {
      type: Array,
      default() {
        return [];
      },
    },

    maxLength: {
      type: Number,
    },

    maxSize: {
      type: Number,
    },

    accept: {
      type: String,
    },

    beforeUpload: {
      type: Function,
      default() {
        return true;
      },
    },
  },

  computed: {
    single() {
      return this.maxLength === 1;
    },

    maxed() {
      return typeof this.maxLength === 'number' && this.fileList.length >= this.maxLength;
    },
  },

  methods: {
    handleBeforeUpload(file) {
      return !this.maxed && (typeof this.maxSize !== 'number' || this.maxSize >= file.size) && this.beforeUpload(file);
    },

    handleChange({ fileList }) {
      if (this.single && fileList.length > 0) {
        fileList = fileList.slice(fileList.length - 1);
      }

      let uploadFile = false;

      let pathList = fileList
        .filter(item => {
          if (item.response && item.response.code != 0) {
            this.$message.error(item.response.msg || '上传失败');
            uploadFile = true;
          }
          return item.status === 'done' && item.response;
        })
        .map(item => {
          if (item.response && item.response.data && item.response.data.url) {
            return item.response.data.url;
          }
        });

      let path = pathList.length > 0 ? pathList[0] : null;

      if (uploadFile) {
        fileList = [];
        pathList = [];
        path = '';
      }

      this.$emit('change', {
        fileList,
        path,
        pathList,
      });
    },
  },
};
</script>

<style scoped></style>
